// 音声の使用額（quiz-production.md 9章）。API が返すトークン数と単価表から計算し、月の上限で止める
import { z } from 'zod';

/** 単価（ドル／100万トークン）。「いつからいくら」で持ち、2027年1月の値上げ（音声の単価が倍）も先に登録しておく */
export type AudioPrice = { from: string; tts: { inPerM: number; outPerM: number }; transcribe: { inPerM: number; outPerM: number } };
export const AUDIO_PRICES: readonly AudioPrice[] = [
  { from: '2026-01-01', tts: { inPerM: 0.5, outPerM: 9.2 }, transcribe: { inPerM: 2.0, outPerM: 2.5 } },
  { from: '2027-01-01', tts: { inPerM: 0.5, outPerM: 18.4 }, transcribe: { inPerM: 2.0, outPerM: 2.5 } },
];

export function priceAt(at: Date, prices: readonly AudioPrice[] = AUDIO_PRICES): AudioPrice {
  const day = new Date(at.getTime() + 9 * 3600_000).toISOString().slice(0, 10);
  return [...prices].filter((p) => p.from <= day).sort((a, b) => b.from.localeCompare(a.from))[0] ?? prices[0]!;
}

/** 1回の呼び出しの使用額（ドル） */
export function audioCostUsd(kind: 'tts' | 'transcribe', usage: { inputTokens: number; outputTokens: number }, at = new Date()) {
  const p = priceAt(at)[kind];
  return (usage.inputTokens * p.inPerM + usage.outputTokens * p.outPerM) / 1_000_000;
}

/** 日本時間の月のはじめ（この時刻以降が「今月」） */
export function jstMonthStart(now = new Date()) {
  const j = new Date(now.getTime() + 9 * 3600_000);
  return new Date(Date.UTC(j.getUTCFullYear(), j.getUTCMonth(), 1) - 9 * 3600_000);
}

export const ReadingEntryBody = z.object({
  word: z.string().trim().min(1, '語を入れてください').max(40),
  reading: z.string().trim().min(1, '読みを入れてください').max(80),
  note: z.string().trim().max(200).default(''),
});

/** 読みの辞書を読み上げ用の文に当てる（長い語から） */
export function applyDictionary(reading: string, entries: { word: string; reading: string }[]) {
  let r = reading;
  for (const e of [...entries].sort((a, b) => b.word.length - a.word.length)) {
    if (!e.word) continue;
    // 数字で始まる語（「3日」など）は、前が数字のときは当てない（「13日」の中の「3日」を「みっか」にしない。2026-10-12）
    if (/^[0-9０-９]/.test(e.word)) r = r.replace(new RegExp(`(?<![0-9０-９])${e.word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'g'), () => e.reading);
    else r = r.split(e.word).join(e.reading);
  }
  return r;
}

/** 概算の円（ドル → 円。画面の目安だけに使う。請求の額ではない。2026-10-13） */
export const USD_JPY = 150;
/** 音声1問（問題＋答え）の使用額の目安（ドル）。記録が無いときに使う（出力 約250トークン × 単価 ＋ 答え） */
export const AUDIO_USD_PER_QUESTION_FALLBACK = 0.003;
